const STORAGE_KEY = 'speedy.selectedCompanyKey';

export function getSelectedCompanyKey(): string | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

export function setSelectedCompanyKey(companyKey: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, companyKey);
  } catch {
    /* ignore */
  }
}

export function clearSelectedCompanyKey(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
